import { render, staticRenderFns } from "./TrocaSenha.vue?vue&type=template&id=6fa1929c&scoped=true"
import script from "./TrocaSenha.vue?vue&type=script&lang=js"
export * from "./TrocaSenha.vue?vue&type=script&lang=js"
import style0 from "./TrocaSenha.vue?vue&type=style&index=0&id=6fa1929c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa1929c",
  null
  
)

export default component.exports